import 'babel-polyfill';

const cookies = require('cookie-getter');

const { host } = window.location;

const DefaultConfig = cookies('config') || {};
const partners = cookies('partners') || {};
const partnerConf = cookies('partner_conf') || {};
const exceptionDomains = cookies('domain_exceptions');

// freeze it if browser supported
if (Object.freeze) {
  Object.freeze(DefaultConfig);
  Object.freeze(partners);
  Object.freeze(partnerConf);
  Object.freeze(exceptionDomains);
}

const partnerCookies = {};
let extraFields = {};
for (const partner in partners) {
  if (partner in partners) {
    const element = partners[partner];
    if (Object.values(exceptionDomains).indexOf(host) < 0) {
      extraFields = {
        legacyFolder: `http://${element}/folder/edit`,
        legacyUrl: `http://${element}`,
        getStateUrl: `http://${element}/api/book`,
        clearThumbnailURL: `http://${element}/api/clearthumbnails`,
      };
    }
    const copyPartnerConf = Object.assign({}, partnerConf, extraFields);
    Object.assign(partnerCookies, { [element]: copyPartnerConf });
  }
}

// export it
const config = Object.assign({}, DefaultConfig, partnerCookies);
export default config;



// WEBPACK FOOTER //
// ./src/services/clientconfig.js